import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';
import { DividendFrequency, DividendPayoutType } from './dividend.types';
import { DIVIDEND_INVALIDATION_KEYS } from './dividend-invalidation.const';

type DividendItemDto = {
  amountPerShare?: number;
  shareClassId?: string;
  stakeholderId?: string;
  totalAmount?: number;
};

type StakeholderDocumentDto = {
  filesLinks: string[];
  stakeholderId: string;
};

export type CreateDividendDto = {
  additionalNotes?: string;
  filesLinks?: string[];
  frequency: DividendFrequency;
  items: DividendItemDto[];
  name: string;
  periodIndex?: null | number;
  stakeholderDocuments?: StakeholderDocumentDto[];
  type: DividendPayoutType;
  year: number;
};

export const useDividendCreate = () => {
  const { invalidateQuery } = useInvalidateQueries(...DIVIDEND_INVALIDATION_KEYS);

  const { isPending, mutate: create } = useAppMutation<unknown, unknown, CreateDividendDto>(
    [QueryKey.CREATE_DIVIDEND_PAYOUT],
    {
      mutationFn: (data) => ApiService.post({ endpoint: BackendRoute.DIVIDENDS }, { body: data }),
      onSuccess: () => {
        invalidateQuery();
      },
    },
  );

  return { create, isPending };
};
